import { redirect } from "@tanstack/react-router";
import { me } from "@/lib/api/auth.functions";
import { canManageCraftPages } from "@/lib/auth/permissions";

/** Redirect to dashboard when the user lacks super-admin Craft pages access. */
export async function ensureCraftPagesAdminAccess() {
  const user = await me();
  if (!user || !canManageCraftPages(user.permissions)) {
    throw redirect({ to: "/admin" });
  }
}
